export * from './SolidClientService';
//# sourceMappingURL=index.js.map